import React from 'react';
import { useEntityIdSelector } from '../../../redux/entity-id-selector.hook';
import { serviceStepAPI } from '../redux/service-steps.slice';

export function useServiceStep(id: string | null | undefined) {
  const { entity: serviceStep } = useEntityIdSelector(serviceStepAPI, id);
  return React.useMemo(() => ({ serviceStep }), [serviceStep]);
}
